import styled from 'styled-components';

export const LabelWithTooltipField = styled.div`
	display: flex;
	flex-direction: column-reverse;
	gap: 4px;
`;

export const GuestUserField = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
`;
